// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__QUQC_","col":"CardReaderDesc_col__2PJce","label":"CardReaderDesc_label__lynGQ"};